import { render, staticRenderFns } from "./EnPage.vue?vue&type=template&id=79347ba6&scoped=true"
import script from "./EnPage.vue?vue&type=script&lang=js"
export * from "./EnPage.vue?vue&type=script&lang=js"
import style0 from "./EnPage.vue?vue&type=style&index=0&id=79347ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79347ba6",
  null
  
)

export default component.exports